import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const getRedirectTarget = (location) => {
  const stateFrom = location.state?.from;
  const stateTarget = stateFrom
    ? `${stateFrom.pathname || ''}${stateFrom.search || ''}${stateFrom.hash || ''}`
    : '';
  const queryRedirect = new URLSearchParams(location.search).get('redirect') || '';
  const candidate = stateTarget || queryRedirect;
  return candidate && candidate.startsWith('/') && !['/', '/login', '/register'].includes(candidate)
    ? candidate
    : '/dashboard';
};

const hasValidAccessToken = () => {
  const token = localStorage.getItem('accessToken');
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp > Date.now() / 1000;
  } catch (_error) {
    return false;
  }
};

function GuestRoute({ children }) {
  const location = useLocation();

  if (hasValidAccessToken()) {
    const invite = new URLSearchParams(location.search).get('invite');
    if (invite && location.pathname === '/register') {
      return <Navigate to={`/company/join?invite=${encodeURIComponent(invite)}`} replace />;
    }
    return <Navigate to={getRedirectTarget(location)} replace />;
  }

  return children;
}

export default GuestRoute;
